import React from 'react'

const CheckboxField = ({field, validate}) => {
  return (
    <div className="form-group">
      <label className="custom-control custom-checkbox">
        <input
          name={field.name}
          type="checkbox"
          className="custom-control-input"
          checked={field.value === true}
          onChange={e => {
            let newValue = !field.value;
            validate(newValue, field);
          }}
        />
        <span className="custom-control-indicator" />
        <span className="custom-control-description">{field.rules.title}</span>
      </label>
    </div>
  )
}

export default (CheckboxField)
